"use client";
import { AppDispatch, AppState } from "@/store/configureStore";
import { updateAddress } from "@/store/slices/userSlice";
import toast from "react-hot-toast";
import axios from "axios";
import { GET_ADDRESSES_API } from "@/constants";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const FetchAddresses = () => {
	const dispatch = useDispatch<AppDispatch>();
	const user = useSelector((state: AppState) => state.user);

	useEffect(() => {
		const fetchAddresses = async () => {
			try {
				const response = await axios.get(GET_ADDRESSES_API, {
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				});
				dispatch(
					updateAddress({
						addresses: response?.data?.addresses,
					})
				);
				// console.log(response?.data)
			} catch (error: string | any) {
				// console.log(`Error: ${error}`)
				// toast.error(`An error occured trying to fetch addresses: ${error.response?.data?.error}`)
			}
		};
		fetchAddresses();
	}, [user, dispatch]);
};
export default FetchAddresses;
